import React from 'react';

import { Controller } from 'react-hook-form';
import NumberInput from '../Inputs/NumberInput';

const ControlledNumberInput = props => {
  const { name, control, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <NumberInput
          value={value}
          onValueChange={values => {
            if (values && values.value !== undefined) {
              onChange(values.value);
              return values.value;
            }
            onChange('');
            return '';
          }}
          {...rest}
        />
      )}
    />
  );
};

export default ControlledNumberInput;
